import { api, defaultQueriesFor } from '../apiSlice';

export const neighborhoodApi = api
  .enhanceEndpoints({ addTagTypes: ['Neighborhood'] })
  .injectEndpoints({
    endpoints: build => ({
      ...defaultQueriesFor(build, 'Neighborhood', 'Neighborhoods', true),
    }),
  });

export const {
  useCreateNeighborhoodMutation,
  useDeleteNeighborhoodMutation,
  useGetNeighborhoodByIdQuery,
  useGetNeighborhoodsQuery,
  useUpdateNeighborhoodMutation,
} = neighborhoodApi;
